import styled, { keyframes } from 'styled-components';
import { Box } from '@rsos/base-components';

export const AudioPlayerContainer = styled(Box).attrs({
  width: '100%',
})``;

export const HiddenAudio = styled.audio`
  display: none;
`;

export const InProgressContainer = styled(Box).attrs(({ theme }) => ({
  width: '100%',
  color: 'secondaryText',
  p: '16px',
  align: 'center',
  border: `1px solid ${theme.colors.heavyLineOutline}`,
  borderRadius: '5px',
}))``;

const pulse = keyframes`
 0% { opacity: 1; }
 50% { opacity: 0.5; }
 100% { opacity: 1; }
`;

export const InProgressDot = styled.div`
  width: 8px;
  height: 8px;
  background-color: ${({ theme }) => theme.colors.lightDanger};
  border-radius: 50%;
  animation: ${pulse} 2s infinite;
`;

export const PlayerContainer = styled(Box).attrs(({ theme }) => ({
  bg: 'background',
  p: '16px',
  border: `1px solid ${theme.colors.heavyLineOutline}`,
  borderRadius: '5px',
}))``;

export const PlayerControls = styled(Box).attrs({
  width: '100%',
  color: 'secondaryText',
  align: 'center',
})``;

export const ProgressBarContainer = styled.div`
  flex-grow: 1;
  background-color: ${({ theme }) => theme.colors.heavyLineOutline};
  height: 4px;
  margin-left: 16px;
  margin-right: 16px;
`;

export const ProgressBar = styled.div<{ progress: number }>`
  background-color: ${({ theme }) => theme.colors.primaryText};
  height: 100%;
  width: ${props => props.progress}%;
  transition: width 0.15s ease;
`;
